import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable()
export class NeoCiiuExcluidoService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'intermediario/service/neoCiiuExcluido';
  }

  getCiiusExcluidosIF(idCliente): Observable<any> {
    return this._http.get(this.url + '/consultar/' + idCliente).pipe(catchError(HandleHttpError));
  }

  saveCiiusExlcuidos(ciiusExcluidos): Observable<any> {
    let body = JSON.stringify(ciiusExcluidos);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/guardar', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }
}
